import clsx from "clsx";
import TextInput from "../TextInput/TextInput";
import React, { KeyboardEvent, useRef } from "react";
import { MdBackspace, MdFilterAlt } from "react-icons/md";
import { useTranslation } from "react-i18next";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind, IButton } from "../Button/Button.types";

interface ITableQuickFilter {
  onChange: (data: any) => void;
  searchTerm: string;
  placeholder?: string;
  buttons?: IButton[];
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
}

const TableQuickFilter: React.FC<ITableQuickFilter> = ({
  onChange,
  searchTerm,
  placeholder = null,
  buttons = [],
  onKeyDown = () => {},
}) => {
  const { t } = useTranslation(["common"]);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={clsx(["flex", "gap-2", "flex-row", "items-center", "w-full"])}
    >
      <MdFilterAlt
        size={ICON_SIZES.SM}
        className={clsx([
          "shrink-0",
          "cursor-pointer",
          {
            "dark:text-purple-500 text-red-500": searchTerm,
          },
        ])}
        onClick={() => {
          if (inputRef?.current) {
            inputRef?.current?.focus?.();
            inputRef?.current?.select?.();
          }
        }}
      />
      <TextInput
        value={searchTerm}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder={placeholder || t("misc:strings.quick_search")}
        className="flex-grow"
        ref={inputRef}
        onKeyDown={onKeyDown}
      />
      <ButtonGroup
        buttons={[
          ...(buttons?.length ? buttons : []),
          {
            icon: <MdBackspace size={ICON_SIZES.SM} />,
            onClick: () => onChange(""),
            disabled: !searchTerm,
            tooltip: t("common:tooltips.reset"),
            kind: searchTerm ? EButtonKind.DANGER : EButtonKind.NORMAL,
          },
        ]}
        align="right"
      />
    </div>
  );
};

export default TableQuickFilter;
